import { useState, useEffect } from "react";
import "./Banner.css";
import Fill_Form_Modal from "../../modals/fill-form-modal/Fill_Form_Modal";
import { useDispatch, useSelector } from "react-redux";
import { GetAllHomeBanner } from "../../../features/components/homepage/homebanner/Slice";
import { IDS } from "../../../utils/IDS";

function Banner() {
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();
  const homebanner = useSelector(
    (state) => state?.homepage?.homebanner?.all_homebanner?.[0] || {},
  );

  useEffect(() => {
    dispatch(GetAllHomeBanner());
  }, [dispatch]);

  return (
    <section className="home_banner">
      <div className="container ">
        <div className="home_banner_content">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="left_col">
                <p className="make_p">
                  {/* Make  */}
                  {homebanner?.name1}
                </p>
                <p className="smart_p">
                  {/* Smarter Career Decisions */}
                  {homebanner?.name2}
                </p>
                <p className="make_p">
                  {/* with <span className="p_span">Expert Guidance</span> */}
                  {homebanner?.name3}
                </p>

                <p className="banner_text">
                  {/* Comprehensive assessments, expert guidance, and personalized
                  career planning for students with dedicated counselling
                  support for parents. */}

                  {homebanner?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
                </p>

                <div className="banner_btn_div">
                  <button
                    className="banner_btn"
                    onClick={() => setShowModal(true)}
                  >
                    Book Counselling Session
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="right_col">
                <div className="right_img_holder">
                  <div className="img_holder">

                  <img
                    src={IDS?.IMG_URL + homebanner?.image}
                    alt="right_img"
                    className="right_img"
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fill_Form_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </section>
  );
}

export default Banner;
